module.exports = __webpack_public_path__ + "static/dancing-in-the-glory-of-monsters-a525e9b7b473507ceedaa232432b41ab.jpg";